<template>
  <div class="sidebar alowscroll" >
    <nav class="sidebar-nav" >
      <ul id="treenav" class="nav" >
        <el-menu router true >
        <el-menu-item index="Dashboard" >
          <i class="fa fa-home fa-2x"></i>
          <span class="menuhome" slot="title">首页</span>
        </el-menu-item>
          <div class="divcslit"><div class="divsplit"></div></div>
        </el-menu>
          <el-menu
            router true
            class="el-menu-vertical-demo"
            ref="menu_data"
            :default-active = "defaultindex"
            :default-openeds = "openeds"
            @open="handleOpen"
            @select="handleSelect"
            @close="handleClose">
            <div v-for="subdata in data.Children" :key="String(subdata.Id)">
              <div v-if = "subdata.Children != null">
                <el-submenu :index="String(subdata.Id)" :route="subdata.ModelUrl">
                  <template slot="title">
                    <i v-bind:class=subdata.Icon.String></i>
                    <span class="menuhome">{{ subdata.Name }}</span>
                  </template>
                  <li class="nav-item" v-for="subsubsubdata in subdata.Children" :key="String(subsubsubdata.Id)">
                    <el-menu-item :index="String(subsubsubdata.Id)" :route="subsubsubdata.ModelUrl.String"><i v-bind:class=subsubsubdata.Icon.String></i> {{ subsubsubdata.Name }}</el-menu-item>
                  </li>
                </el-submenu>
              </div>
              <div v-else>
                <el-menu-item :index="String(subdata.Id)" :route="subdata.ModelUrl.String"><i v-bind:class=subdata.Icon.String></i> {{ subdata.Name }}</el-menu-item>
              </div>
            </div>
          </el-menu>
      </ul>
    </nav>
  </div>
</template>
<script>
import { EventBus } from '../../util/event-bus.js'
import ElMenu from '../../../node_modules/element-ui/packages/menu/src/menu'
var that
export default {
  components: {ElMenu},
  name: 'sidebar',
  data () {
    return {
      data: [],
      openeds: [],
      hiddenul: true,
      contentObjwidth: '',
      defaultindex: '540',
      isCollapse: false
    }
  },
  mounted: function () {
    EventBus.$on('mainmenuchange', ({mainmenuid}) => {
      window.console.log('执行的菜单ID', mainmenuid)
      var data = JSON.parse(localStorage.getItem('models'))
      for (var j = 0; j < data[0].Children.length; j++) {
        if (mainmenuid === data[0].Children[j].Id) {
          that.data = data[0].Children[j]
          console.log(that.data)
          for (var k = 0; k < that.data.Children.length; k++) {
            var subsubdata = that.data.Children[k]
            if (subsubdata.Level === 2) {
              this.openeds.push(subsubdata.Id)
            }
          }
        }
      }
    })
    if (localStorage.getItem('SelectMainMenuID') !== undefined && localStorage.getItem('SelectMainMenuID') !== null && localStorage.getItem('SelectMainMenuID') !== '') {
      window.console.log(localStorage.getItem('SelectMainMenuID'))
    } else {
      localStorage.setItem('SelectMainMenuID',1)
    }
    var mainmenuidtmp = localStorage.getItem('SelectMainMenuID')
    var data = JSON.parse(localStorage.getItem('models'))
    for (var j = 0; j < data[0].Children.length; j++) {
      window.console.log(mainmenuidtmp === data[0].Children[j].Id)
      window.console.log(mainmenuidtmp)
      window.console.log(data[0].Children[j].Id)
      if (mainmenuidtmp === data[0].Children[j].Id) {
        that.data = data[0].Children[j]
        console.log(that.data)
        for (var k = 0; k < that.data.Children.length; k++) {
          var subsubdata = that.data.Children[k]
          if (subsubdata.Level === 2) {
            this.openeds.push(subsubdata.Id)
          }
        }
      }
    }
    this.defaultindex = localStorage.getItem('SelectMenuKey')
  },
  created: function () {
    that = this
    var data = JSON.parse(localStorage.getItem('models'))
    this.openeds = []
    var menuselect = []
    for (var j = 0; j < data[0].Children.length; j++) {
      var subdata = data[0].Children[j]
      menuselect.push(subdata.Id)
      if (subdata.Children.length > 0) {
        for (var k = 0; k < subdata.Children.length; k++) {
          var subsubdata = subdata.Children[k]
          if (subsubdata.Level === 2) {
            this.openeds.push(subsubdata.Id)
          }
        }
      }
    }
    /*
    var mainmenuid = localStorage.getItem('SelectMainMenuID')
    var menuindex
    switch (mainmenuid) {
      case '98': {
        menuindex = 0
        break
      }
      case '99': {
        menuindex = 1
        break
      }
      case '100': {
        menuindex = 2
        break
      }
      case '101': {
        menuindex = 3
        break
      }
      case '102': {
        menuindex = 4
        break
      }
      case '137': {
        menuindex = 5
        break
      }
      default: {
        menuindex = 0
        break
      }
    }
    for (var i = 0; i < data[0].Children.length; i++) {
      if (data[0].Children[i].Id === menuselect[menuindex]) {
        this.data = data[0].Children[i]
      }
    }
     */
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      console.log('keyPath')
      console.log(keyPath)
      console.log('key')
      console.log(key)
      localStorage.setItem('SelectMenuKey',key)
      // setCookie('SelectMenuID', key, 1)
      // setCookie('SelectMenuPath', keyPath, 1)
      if (document.documentElement.clientWidth < 600) {
        document.body.classList.toggle('sidebar-mobile-show')
      }
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
  .menuhome {
    margin-left: 10px;
    font-size: 18px;
    font-weight: 400;
    line-height: 1;
  }
  .sub-nav-link {
    padding-left: 20px;
    font-size:13px;
    color:#444;
  }
  .alowscroll
  {
    height:100%;
    overflow:auto
  }

  /**左侧导航栏**/
  .sidebar
  {
    padding: 0;
    background-color: #fff;
  }
  .sidebar .nav .nav-item .nav-link, .sidebar .nav .nav-item .navbar .dropdown-toggle, .navbar .sidebar .nav .nav-item .dropdown-toggle {
    display: block;
    padding: 0.75rem 1rem;
    color: #000;
    text-decoration: none;
    background: transparent;
  }
  /**左侧导航栏展开**/
  .sidebar .nav .nav-item.nav-dropdown.open
  {
    background-color: #fff;
    color:#000;
  }
  .sidebar .nav .nav-item.nav-dropdown.open a.nav-link, .sidebar .nav .nav-item.nav-dropdown.open .navbar a.dropdown-toggle, .navbar .sidebar .nav .nav-item.nav-dropdown.open a.dropdown-toggle {
    color: #000;
    border-left: 0 !important;
  }
  /**左侧导航鼠标划过**/
  .sidebar .nav .nav-item .nav-link:hover, .sidebar .nav .nav-item .navbar .dropdown-toggle:hover, .navbar .sidebar .nav .nav-item .dropdown-toggle:hover {
    color: #3284ea !important;
    background: #e9ebf0 !important;
  }
  .sidebar .sidebar-nav::-webkit-scrollbar-track {
    background-color: #fff;
    border-right: 0px solid #377ae6;
    border-left: 0px solid #377ae6;
  }
  .sidebar .sidebar-nav::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #6d91cc;
    background-clip: content-box;
    border-color: transparent;
    border-style: solid;
    border-width: 1px 2px;
  }
  .divcslit {
    align:center;
    height: 20px;
  }
  .divsplit {
    margin:0 auto;
    width: 100px;
    height: 0.5px;
    line-height:20px;
    background-color: #cccccc;
    border-color: transparent;
    border-style: solid;
    border-width: 0.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue